import MenuItemPage from 'apps/Diner/MenuItemPage/MenuItemPage'
import DinerContainer from 'apps/Diner/DinerApp/DinerContainer'

const MenuItemPageContainer = (): JSX.Element => {
  return <MenuItemPage />
}

MenuItemPageContainer.getLayout = (page: JSX.Element) => {
  return <DinerContainer>{page}</DinerContainer>
}

export default MenuItemPageContainer
